"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setRuleName')(function setRuleName(newRuleName) {
    store_1.default.inboxRulesEditState.ruleName = newRuleName;
});
//# sourceMappingURL=setRuleName.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/setRuleName.js
// module id = 5210
// module chunks = 2